module.exports = __webpack_public_path__ + "media/react/payments/assets/google_pay_dark-33dc364f5f115f4164259ff7007e90e5.svg";